import React, { useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import * as XLSX from "xlsx";
import { Button, Col, Modal, Row } from "react-bootstrap";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

function Map({ markers, intervalValue }) {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const polylineRef = useRef(null);
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [map, setMap] = useState(null); // state to hold the map instance

  useEffect(() => {
    if (!mapRef.current || markers.length === 0) return;

    const loader = new Loader({
      apiKey: "AIzaSyCjaL0qDqYI1-s6EwzwRCeRGCBVPKYUlf8",
      version: "weekly",
    });

    loader.load().then(() => {
      const mapInstance = new window.google.maps.Map(mapRef.current, {
        //center: { lat: 10.671990660571442, lng: 76.11267293826873 },
        zoom: 25,
        mapTypeId: "roadmap",
      });

      setMap(mapInstance); // store the map instance in state

      const bounds = new window.google.maps.LatLngBounds();
      markers.forEach((coord) => bounds.extend(coord));
      mapInstance.fitBounds(bounds);

      markerRef.current = new window.google.maps.Marker({
        position: markers[0], // Initialize marker position
        map: mapInstance,
        icon: {
          path: "M 0,0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0", // SVG path for a circle with radius 5px
          fillColor: "red", // Color of the dot
          fillOpacity: 1, // Opacity of the dot
          strokeWeight: 0, // No border
          scale: 1, // Scale factor
        },
      });

      polylineRef.current = new window.google.maps.Polyline({
        path: [],
        geodesic: true,
        strokeColor: "red",
        strokeOpacity: 0.5,
        strokeWeight: 4,
        map: mapInstance,
      });

      // Start animation
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === markers.length - 1 ? 0 : prevIndex + 1
        );
        moveMarker();
      }, intervalValue); // Change the interval time (in milliseconds) as desired

      return () => clearInterval(intervalRef.current); // Clean up interval on unmount

      // setLoading(false);
    });
  }, [markers, intervalValue]);

  const moveMarker = () => {
    const currentPosition = markerRef.current.getPosition();
    const path = polylineRef.current.getPath();
    path.push(currentPosition); // Add current position to the path
    polylineRef.current.setPath(path); // Update the path of the Polyline
    // Your logic to move the marker here
  };

  useEffect(() => {
    console.log(currentIndex, markers.length);
    if (currentIndex === markers.length - 1) {
      clearInterval(intervalRef.current); // Clear the interval to stop the animation
    }
  }, [currentIndex, markers]);

  // Update marker position when currentIndex changes
  useEffect(() => {
    if (markerRef.current && map) {
      markerRef.current.setPosition(markers[currentIndex]);
      map.panTo(markers[currentIndex]); // Pan the map to the current marker position
    }
  }, [currentIndex, markers, map]);

  return (
    <div>
      {/* {loading ? (
        <div>Loading...</div>
      ) : ( */}
      <div ref={mapRef} style={{ width: "100%", height: "100vh" }} />
      {/* )} */}
    </div>
  );
}

function App() {
  const [markers, setMarkers] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [sheetNameVal, setSheetNameVal] = useState(0);
  const [intervalVal, setIntervalVal] = useState(0);
  const handleChange = (event) => {
    setSheetNameVal(event.target.value);
  };
  const handleIntervalChange = (event) => {
    setIntervalVal(event.target.value);
  };

  const handleFileUpload = async () => {
    try {
      const arrayBuffer = await selectedFile.arrayBuffer();
      const data = new Uint8Array(arrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[sheetNameVal]; // Assuming data is in the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const markerData = XLSX.utils.sheet_to_json(worksheet);

      // Extract latitude and longitude from marker data
      const extractedMarkers = markerData.map((row) => ({
        lat: parseFloat(row["Lat in Degrees"]),
        lng: parseFloat(row["Long in Degrees"]),
      }));
      setMarkers(extractedMarkers);
      setShowModal(false); // Close modal after successful file upload
    } catch (error) {
      console.error("Error reading markers from Excel file:", error);
    }
  };

  return (
    <div className="App">
      <div className="container">
        <h1>Map with Markers from Excel</h1>
        {/* <div>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleUpload}>Upload</button>
    </div> */}

        <Button onClick={() => setShowModal(true)} className="mb-2">
          Upload Excel File
        </Button>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Excel File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="file"
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
          <br />
          <br />
          <label>Sheet No:</label>
          <input
            type="number"
            className="form-control"
            onChange={handleChange}
          />
          <br />
          <br />
          <label>Interval</label>
          <input
            type="number"
            className="form-control"
            onChange={handleIntervalChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleFileUpload}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>
      <Map markers={markers} intervalValue={intervalVal} />
    </div>
  );
}

export default App;
